import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const addPainAssessmentEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_PAIN_ASSESSMENT();
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error posting data: ${error.message}`);
  }
};

export const updatePainAssessmentEndpoint = async (painAssessmentId, data) => {
  const endpoint = API_ENDPOINTS.UPDATE_PAIN_ASSESSMENT(painAssessmentId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating pain assessment: ${error.message}`);
  }
};

export const deletePainAssessmentEndpoint = async painAssessmentId => {
  const endpoint = API_ENDPOINTS.DELETE_PAIN_ASSESSMENT(painAssessmentId);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error.message;
    throw new Error(`${errorMessage}`);
  }
};
